import _                                     from 'underscore';
import { v4 as uuid }                        from 'uuid';
import { gql }                               from 'apollo-boost';
import { BaseStore }                         from './BaseStore';
import { asType, isResolver, withResolvers } from './_apolloUtil';
import { UserQueries }                       from '../queries';
import { UserService }                       from '../services';

@withResolvers
export class UserStore extends BaseStore {
	
	static storeKey      = 'user';
	static storeTypename = 'UserStore';
	static typeDefs      = `
		type UserStore {
			guid:       String
			welcomMssg: String
		}
	`;
	
	static state = asType( UserStore.storeTypename, {
		guid:       uuid(),
		welcomMssg: null,
	} );
	
	/**
	 * Rehydrates this user store, and the current user,
	 * by way of auth token stored inside a cookie.
	 *
	 * @param apolloClient
	 * @returns Promise
	 * @public
	 */
	static async hydrateUserToken( apolloClient ){
		
		let hyrdationObject = UserStore.state;
		try {
			// see if we can get the current user...
			let { data: returningUser } = await apolloClient.query( { query: UserQueries.queries.GET_CURRENT_USER() } );

			if ( returningUser ) {

				hyrdationObject.welcomMssg = `Welcome back, ${ returningUser.me.emailAddress }`;

			} else {

				// console.warn( `Token timed out, please log back in.` );
			}
		} catch (e) { }
		// Return with anything we want to store in _this_ store.
		// note: user is set inside cache on it's own remote data area, not here.
		return Promise.resolve( hyrdationObject );
	}
	
	/**
	 * Updates this store; queries for given items, then updates store
	 * via immer's draft function, passed in by the user
	 *
	 * @param _user
	 * @param queryVars<Object> ({ queriedItems, updateFunction })
	 * @param apollo
	 * @returns void
	 * @public
	 */
	@isResolver( 'Mutation' )
	static updateStore( _user, { queriedItems, updateFunction }, { client } ){
		
		// define what toquery from the store so we can update it; can come in array or string form
		let storeItems = _.isArray( queriedItems ) ? queriedItems.join( ',' ) : queriedItems;
		
		UserStore.updateState( gql`{ user @client { ${ storeItems } } }`, updateFunction, client );
	}
	
	@isResolver( 'Mutation' )
	static logoutUser( _user, _, { client } ){
		
		// reset to initial state values (see ./_apollo.js)
		client.onResetStore( () => {
			
			client.writeState( client.getInitialState() );
		} );
		
		// reset queries and data within the cache
		client.resetStore();
	}
}
